import { apiSlice } from '../../api/apiSlice';
import { BuildQueryParams } from '../utils/buildQueryParams';

export const reportApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSessionReportOptions: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/ReportOptions?reportOptionType=${option.reportOptionType || 0}&isRetakeReport=${option.isRetakeReport}`,
        method: 'GET',
        credentials: 'include'
      })
    }),

    getStudentSessionReport: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/StudentSessionReport/${option.studentId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getStudentSessionReportBySessionId: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/Session/${option.sessionId}/Student/${option.studentId}/SessionReport`,
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    setReportOptions: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/ReportOptions?reportOptionType=${option[1].reportOptionType || 0}&isRetakeReport=${option[1].isRetakeReport}`,
        method: 'PUT',
        credentials: 'include',
        body: option[0]
      })
    }),

    getViewVocabulary: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/GetVocabulary/${option.id}?courseId=${option.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),

    getViewStandard: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/GetStandard/${option.stateCourseId}?standardNumber=${option.standardNumber}&stateId=${option.stateId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getVocabulary: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/Student/${option.studentId}/GetVocabulary`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    export: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/StudentSessionReport/${option.studentId}/Export`,
        method: 'GET',
        credentials: 'include'
      })
    }),

    getAnswerBreakdownReport: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/AnswerBreakdown`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getCumulativeAssignmentReport: builder.mutation({
      query: (option) => ({
        url: `/AssignmentReport/${option.assignmentId}/CumulativeAssignmentReport?classId=${option.classId}${option.studentId ? `&studentId=${option.studentId}` : ''}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getCumulativeAssignmentReportWithRetakes: builder.mutation({
      query: (option) => ({
        url: `/AssignmentReport/${option.assignmentId}/CumulativeAssignmentReportWithRetakes?classId=${option.classId}${option.studentId ? `&studentId=${option.studentId}` : ''}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getQuestionAnswerResponse: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/Session/${option.sessionId}/QuestionResponse/${option.questionId}?courseId=${option.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getScoreReport: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/assignmentId/ScoreReport/${option.classId}?assignmentId=${option.assignmentId}&publicAssignmentId=${option.publicAssignmentId}&teacherId=${option.teacherId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssignmentIncompleteScoringOption: builder.mutation({
      query: () => ({
        url: 'AssignmentReport/IncompleteScoring',
        method: 'GET',
        credentials: 'include'
      })
    }),
    patchAssignmentIncompleteScoringOption: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/IncompleteScoring?incompleteScoring=${option.incompleteScoring}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getAssignmentPointsOPtions: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/PointsOption?option=${option.option}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    patchAssignmentPointsOPtions: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/PointsOption?option=${option.option}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    exportSpreadSheet: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/ExportSpreadSheet`,
        method: 'GET',
        credentials: 'include',
        params : {classId:option.classId}
      })
    }),
    getVocabularyStudySheet: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/Student/${option.studentId}/GetVocabularyStudySheet`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getTimeOnTaskReport: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/TimeOnTaskReport`,
        method: 'GET',
        credentials: 'include',
        params : {...option}
      })
    }),
    getTimeOnTaskReportAllAssignment: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/TimeOnTaskReport/Course/${option.courseId}`,
        method: 'GET',
        credentials: 'include',
        params : {...option}
      })
    }),
    getStudentTimeOnTaskReport: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/Student/${option.studentId}/TimeOnTaskReport`,
        method: 'GET',
        credentials: 'include',
        params : {includeRetakes : option.includeRetakes}
      })
    }),
    getComprehensiveReport: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/ComprehensiveReport?classId=${option.classId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getComprehensiveReportOptions: builder.mutation({
      query: () => ({
        url: 'AssignmentReport/ComprehensiveReportOptions',
        method: 'GET',
        credentials: 'include'
      })
    }),
    setComprehensiveReportOptions: builder.mutation({
      query: (option) => ({
        url: 'AssignmentReport/ComprehensiveReportOptions',
        method: 'PUT',
        credentials: 'include',
        body: option
      })
    }),
    getAssignmentCourses: builder.mutation({
      query: (options) => ({
        url: 'TeacherReport/AllAssignments',
        method: 'GET',
        credentials: 'include',
        params:{...options}
      })
    }),
    getAssignmentStudentsList: builder.mutation({
      query: (options) => ({
        url: `TeacherReport/Assignment/${options.assignmentId}/Students/${options.skip}/${options.take}`,
        method: 'GET',
        credentials: 'include',
        params:{...options}
      })
    }),
    getAssignmentClasses: builder.mutation({
      query: (options) => ({
        url: `TeacherReport/Assignment/${options.assignmentId}/Classes`,
        method: 'GET',
        credentials: 'include',
        params:{...options}
      })
    }),
    getSingleStudentAssignmentsScore: builder.mutation({
      query: (options) => ({
        url: `TeacherReport/Scores/Student/${options.studentId}`,
        method: 'GET',
        credentials: 'include',
        params:{...options}
      })
    }),
    getAllStudentAssignmentsScore: builder.mutation({
      query: (options) => ({
        url: 'TeacherReport/Scores',
        method: 'POST',
        credentials: 'include',
        body:options
      })
    }),
    getAllAssignmentCumulativeReport: builder.mutation({
      query: (options) => ({
        url: 'TeacherReport/AllAssignmentCumulativeReport',
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    getLoginActivityReport: builder.mutation({
      query: (options) => ({
        url: `TeacherReport/LoginActivityReport?studentId=${options.studentId}&classId=${options.classId}&assignmentId=${options.assignmentId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getGrowthReport: builder.mutation({
      query: (options) => ({
        url: 'TeacherReport/GrowthReport',
        method: 'GET',
        credentials: 'include',
        params: {...options}
      })
    }),
    getClassName: builder.mutation({
      query: (classId) => ({
        url: `Class/GetClassName/${classId}`,
        method: 'GET',
        responseHandler: 'text'
      })
    }),
    getStudentName: builder.mutation({
      query: (studentId) => ({
        url: `Student/GetStudentName/${studentId}`,
        method: 'GET',
        responseHandler: 'text'
      })
    }),
    getItemAnalysisReport: builder.mutation({
      query: (params) => ({
        url: `TeacherReport/ItemAnalysisReport?${params}`,
        method: 'GET',
        credentials: 'include',
      })
    }),
    getCrStudentResponse: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/Question/${option.questionId}/CRStudentResponse`,
        method: 'GET',
        credentials: 'include',
      })
    }),
    assignmentResponse: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/${option.assignmentId}/Student/${option.studentId}/Results`,
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    sessionResponse: builder.mutation({
      query: (option) => ({
        url: `AssignmentReport/Session/${option.sessionId}/Student/${option.studentId}/Results`,
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    selfStudyReport: builder.query({
      query: (params) => {
        return {
          url: `TeacherReport/SelfStudyReport/ClassSummary?${BuildQueryParams(params)}`,
          method: 'GET',
          credentials: 'include'
        };
      },
      extraOptions: { showGlobalError: true }
    }),
    getSelfStudyCumulativeSummary: builder.mutation({
      query: (params) => ({
        url: `TeacherReport/SelfStudyReport/CumulativeSummary?${BuildQueryParams(params)}`,
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getIncompleteSelfStudy: builder.mutation({
      query: (params) => ({
        url: `TeacherReport/SelfStudyReport/Incomplete?${BuildQueryParams(params)}`,
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getSelfStudyCumulativeReport: builder.mutation({
      query: (params) => ({
        url: `TeacherReport/SelfStudyCumulativeReport?${BuildQueryParams(params)}`,
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getStudentSelfStudySessions: builder.mutation({
      query: (options) => ({
        url: `TeacherReport/SelfStudyReport/Student/${options.studentId}?${BuildQueryParams({ courseIds: options.courseIds })}`,
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    })
  })
});

export const {
  useGetSessionReportOptionsMutation,
  useGetStudentSessionReportMutation,
  useGetStudentSessionReportBySessionIdMutation,
  useSetReportOptionsMutation,
  useGetViewVocabularyMutation,
  useGetViewStandardMutation,
  useGetVocabularyMutation,
  useExportMutation,
  useGetAnswerBreakdownReportMutation,
  useGetCumulativeAssignmentReportMutation,
  useGetCumulativeAssignmentReportWithRetakesMutation,
  useGetQuestionAnswerResponseMutation,
  useGetScoreReportMutation,
  useGetAssignmentIncompleteScoringOptionMutation,
  usePatchAssignmentIncompleteScoringOptionMutation,
  useGetAssignmentPointsOPtionsMutation,
  usePatchAssignmentPointsOPtionsMutation,
  useExportSpreadSheetMutation,
  useGetVocabularyStudySheetMutation,
  useGetTimeOnTaskReportMutation,
  useGetTimeOnTaskReportAllAssignmentMutation,
  useGetStudentTimeOnTaskReportMutation,
  useGetComprehensiveReportMutation,
  useGetComprehensiveReportOptionsMutation,
  useSetComprehensiveReportOptionsMutation,
  useGetAssignmentCoursesMutation,
  useGetAssignmentStudentsListMutation,
  useGetAssignmentClassesMutation,
  useGetSingleStudentAssignmentsScoreMutation,
  useGetAllStudentAssignmentsScoreMutation,
  useGetAllAssignmentCumulativeReportMutation,
  useGetLoginActivityReportMutation,
  useGetGrowthReportMutation,
  useGetClassNameMutation,
  useGetStudentNameMutation,
  useGetItemAnalysisReportMutation,
  useGetCrStudentResponseMutation,
  useAssignmentResponseMutation,
  useSessionResponseMutation,
  useSelfStudyReportQuery,
  useGetSelfStudyCumulativeSummaryMutation,
  useGetIncompleteSelfStudyMutation,
  useGetSelfStudyCumulativeReportMutation,
  useGetStudentSelfStudySessionsMutation
} = reportApi;
